import { ICountry } from '../../types/models'

export const getPhone = (
  fullPhone: string | null,
  country: ICountry
): string => {
  return fullPhone ? fullPhone.replace(country.code, '') : ''
}
